import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SessionTitleConfig } from '@core/models/built/procedure-step-config.model';
import { ProcedureStep } from '@core/models/procedures.model';
import { FlowchartMode } from '@flowchart';
import { TranslocoService } from '@ngneat/transloco';
import { filterTruthy } from '@utils';
import { BehaviorSubject } from 'rxjs';

import it from './i18n/session-title-edit.it.json';

@Component({
  templateUrl: './session-title-edit.component.html'
})
export class SessionTitleEditComponent implements OnInit, OnDestroy {

  @Input() step!: ProcedureStep;
  @Input() mode: FlowchartMode = 'edit';
  @Input() editForm!: FormGroup;

  private step$$ = new BehaviorSubject<ProcedureStep | undefined>(undefined);
  step$ = this.step$$.pipe(filterTruthy());

  constructor(
    private fb: FormBuilder,
    private translocoSvc: TranslocoService
  ) {
    this.translocoSvc.setTranslation(it, 'it');
  }

  ngOnInit() {
    const config = this.step.config as SessionTitleConfig;

    let configGroup = (this.editForm.get('config') as FormGroup);
    if (!configGroup) {
      this.editForm.addControl('config', this.fb.group({}));
      configGroup = (this.editForm.get('config') as FormGroup);
    }
    configGroup.addControl('sessionTitle', this.fb.control(config?.sessionTitle, [Validators.required]));
    configGroup.addControl('sessionDescription', this.fb.control(config?.sessionDescription));

    if (this.mode === 'view') {
      (this.editForm.get('config') as FormGroup).disable();
    }
  }

  ngOnDestroy() {
    const configGroup = (this.editForm.get('config') as FormGroup);
    if (configGroup) {
      configGroup.removeControl('sessionTitle');
      configGroup.removeControl('sessionDescription');

      if (Object.keys(configGroup.controls).length <= 0) {
        this.editForm.removeControl('config');
      }
    }
  }
}
